import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/product/products?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/product/products/${id}`, { params });
}

export async function create(body) {
  return request(`/product/products`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/product/products/${id}`, {
    method: 'POST',
    body,
  });
}